import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import sagas from "../sagas/sagas";
import mobileFrame from "./mobile-frame-home-page.store";
import manualCommandList from "./data/common-data.store";
import commandListPage from "./command-list-page.store";
import commandDetailPage from "./command-detail-page.store";
import eventStatusListPage from "./event-status-list-page.store";
import blocksSounds from "./blocks-sounds-page.store";
import assistance from "./assistance-page.store";
import calendarEvent from "./calendar-event-page.store";
import addCalendarEvent from "./add-calendar-event-page.store";
import eklokLineStatus from "./eklok-line-status.store";

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({
  mobileFrame: mobileFrame,
  manualCommandList: manualCommandList,
  commandListPage: commandListPage,
  commandDetailPage: commandDetailPage,
  eventStatusListPage: eventStatusListPage,
  blocksSounds: blocksSounds,
  assistance: assistance,
  calendarEvent: calendarEvent,
  addCalendarEvent: addCalendarEvent,
  eklokLineStatus: eklokLineStatus,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(sagas);

export default store;
